import { call, put, takeEvery} from "redux-saga/effects";
import {
  GET_APPLICATION_SUBSTATUS_DEF,
} from "./actionTypes"

import {

  getApplicationSubStatusDefSuccess,
  applicationSubStatusDefError
  
} from "./actions"

//Include Both Helper File with needed methods
import {
getApplicationSubStatusDef

} from "../../helpers/backend_helper/backend_helper"

import { toast,Zoom } from "react-toastify";
import i18n from 'i18n';

function* onGetApplicationSubStatusList() {
  try {
    const response = yield call(getApplicationSubStatusDef)
    yield put(getApplicationSubStatusDefSuccess(response))
   //toast.success(i18n.t('successful'), { autoClose: 2000, position: toast.POSITION.BOTTOM_LEFT, transition: Zoom });
  } catch (error) {
    yield put(applicationSubStatusDefError(error))
  }
}

function* applicationSubStatusDefManagementSaga() {

    yield takeEvery(GET_APPLICATION_SUBSTATUS_DEF,onGetApplicationSubStatusList)
}

export default applicationSubStatusDefManagementSaga
